import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { DrycutApolloProvider } from 'drycut-apollo';
import { RouterProvider } from 'react-router';
import router from './router';
import 'tailwindcss/tailwind.css';
import './styles.css';
import { AuthProvider } from 'drycut-auth';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <DrycutApolloProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </DrycutApolloProvider>
  </StrictMode>,
);
